import api from './api';

export interface Banner {
  id: number | string;
  name: string;
  image_url?: string;
  click_url?: string;
  placement?: string;
  width?: number;
  height?: number;
  is_active?: boolean;
  display_order?: number;
}

export async function getBanners(params?: { active?: boolean; placement?: string }): Promise<Banner[]> {
  const res = await api.get<any>('/banners', { params });
  const body = res.data;
  const list = Array.isArray(body) ? body : (Array.isArray(body?.data) ? body.data : []);
  return (list || []).map((b: any) => ({
    ...b,
    id: b.id ?? b.ID ?? b.Id ?? b.iD,
  }));
}

export async function createBanner(payload: { name: string; image_url?: string; click_url?: string; placement?: string; width?: number; height?: number; is_active?: boolean; display_order?: number }) {
  const res = await api.post<Banner>('/banners', payload);
  return res.data;
}

export async function updateBanner(id: number | string, payload: Partial<{ name: string; image_url?: string; click_url?: string; placement?: string; width?: number; height?: number; is_active?: boolean; display_order?: number }>) {
  const res = await api.put<Banner>(`/banners/${id}`, payload);
  return res.data;
}

export async function deleteBanner(id: number | string) {
  const res = await api.delete<{ zprava: string }>(`/banners/${id}`);
  return res.data;
}
